export const YOUTUBE = "YouTube";
export const SALESFORCE_NEWS = "Salesforce News";
export const ALL = "all";
export const SERIES = "series";
export const QUESTIONS = "Questions";
export const FEATURED = "FEATURED";
export const PREMIUM = "PREMIUM";
export const SECTIONS = "SECTIONS";
export const FREE = "free";
export const PAID = "paid";
export const ORDERS_PER_PAGE = 10;
export const EBOOK = "E-Book";
export const INTERNSHIP = "Internship";
export const LONGSWITCH_ACADEMY = "LONGSWITCH_ACADEMY";
export const MAX_FILE_SIZE = 2 * 1024 * 1024;
export const ONLINE = "online";
export const OFFLINE = "offline";
export const NETWORK_SLOW_2G = "slow-2g";
export const NETWORK_2G = "2g";
export const NETWORK_3G = "3g";